// Novo componente chamado LoginContent.tsx
import React from 'react';
import { Box, Typography, Divider, TextField, Button, useTheme, Card, CardContent } from '@mui/material';
import { ArrowBack, Send } from '@mui/icons-material';

interface RecoveryContentProps {
  user: string;
  setEmail: (value: string) => void;
  handleSubmitRecovery: () => void;
  setRecovery: (value: boolean) => void;
  error: boolean;
  requestError: string;
}

export const RecoveryForm: React.FC<RecoveryContentProps> = ({
  setEmail,
  handleSubmitRecovery,
  setRecovery,
  error,
  requestError
}) => {
  const theme = useTheme();

  return (
    <Card>
        <CardContent>
            <Box padding={1}>
                <Box display={'flex'} flexDirection={'column'} gap={2} width={250}>
                    <Box>
                        <Typography variant='h5' align='left' color={theme.palette.primary.main}>
                            Recuperação de Senha
                        </Typography>
                        <Typography variant='body1' align='left'>
                            Informe seu e-mail para receber um link de recuperação
                        </Typography>
                        <Divider flexItem variant='fullWidth' orientation='horizontal' color={theme.palette.primary.main} />
                    </Box>

                    <TextField
                        error={error}
                        fullWidth
                        label='E-mail'
                        onChange={(e) => setEmail(e.target.value)}
                    />

                </Box>
                {error? (<><Typography color={'red'}>{requestError}</Typography></>): null}
                <Box width={'100%'} display={'flex'} justifyContent={'center'} flexDirection={'row'} gap={2} marginTop={2}>
                    <Button startIcon={<ArrowBack />} variant='contained' onClick={() => setRecovery(false)} fullWidth>
                        Voltar
                    </Button>
                    <Button startIcon={<Send />} variant='contained' onClick={handleSubmitRecovery} fullWidth>
                        Enviar
                    </Button>
                </Box>
            </Box>
        </CardContent>
    </Card>
  );
};